import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import './dashboard.css';
import { useAuth } from '../../contexts/AuthContext';
// usePermission import removed — only used in commented-out code (Story 8.2)
import AdminDashboard from './admin';
// import StudentDashboard from './student'; // Legacy
import CoachDashboard from './coach';
import BalagruhaDashboard from './balagruha';
import MedicalInchargeDashboard from './MedicalInchargeDashboard';
import PurchaseDashboard from './purchaseDashboard';
import PurchaseManagerDashboard from './PurchaseManagerDashboard';
import SportCoachDashboard from './Sportscoach';
import MusicCoachDashboard from './MusicCoach';
import { UserTypes, STUDENT_HOME_PATH, normalizeUserRole } from '../../constants/userTypes';
// const Dashboard = () => {
//     const { user } = useAuth();
//     const { canRead } = usePermission();

//     // Define modules and their routes
//     const modules = [
//         {
//             name: 'User Management',
//             icon: '👥',
//             path: '/users',
//             hasAccess: canRead('User Management')
//         },
//         {
//             name: 'Role Management',
//             icon: '🔑',
//             path: '/rbac',
//             hasAccess: canRead('Role Management')
//         },
//         {
//             name: 'Task Management',
//             icon: '📋',
//             path: '/task',
//             hasAccess: canRead('Task Management')
//         },
//         {
//             name: 'Machine Management',
//             icon: '🖥️',
//             path: '/machines',
//             hasAccess: canRead('Machine Management')
//         }
//     ];

//     // Filter modules to only show those the user has access to
//     const accessibleModules = modules.filter(module => module.hasAccess);

//     return (
//         <div className="dashboard">
//             <div className="page-header">
//                 <h1>Dashboard</h1>
//             </div>

//             <div className="welcome-card">
//                 <h2>Welcome, {user?.name}!</h2>
//                 <p>Role: <span className="role-badge">{user?.role}</span></p>
//                 <p>Today is {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
//             </div>

//             {accessibleModules.length > 0 ? (
//                 <div className="modules-section">
//                     <h2>Your Accessible Modules</h2>

//                     <div className="modules-grid">
//                         {accessibleModules.map(module => (
//                             <div key={module.name} className="module-card">
//                                 <div className="module-icon">{module.icon}</div>
//                                 <h3>{module.name}</h3>
//                                 <Link to={module.path} className="module-link">
//                                     Go to {module.name}
//                                 </Link>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             ) : (
//                 <div className="no-modules">
//                     <p>You don't have access to any modules yet.</p>
//                     <p>Please contact an administrator if you need access.</p>
//                 </div>
//             )}
//         </div>
//     );
// };

const Dashboard = () => {
    const role = normalizeUserRole(localStorage.getItem('role'));

    // Redirect students to the new layout/dashboard
    if (role === UserTypes.STUDENT) {
        return <Navigate to={STUDENT_HOME_PATH} replace />;
    }

    return (
        <>

            {/* ['admin', 'coach', 'balagruha in-charge', 'student', 'purchase-manager',
    'medical-incharge', 'sports-coach', 'music-coach', 'amma'] */}
            {
                role === UserTypes.ADMIN ? <AdminDashboard /> : role === UserTypes.COACH ? <CoachDashboard /> : role === UserTypes.IN_CHARGE ? < PurchaseDashboard /> : role === UserTypes.MEDICAL_IN_CHARGE ? <MedicalInchargeDashboard /> : role === UserTypes.PURCHASE_MANAGER ? <PurchaseManagerDashboard /> : role === UserTypes.SPORTS_COACH ? <MusicCoachDashboard /> : <MusicCoachDashboard />
            }
        </>
    )
}
export default Dashboard;
